export default __webpack_public_path__ + "static/media/wallet.946b6e3c.webp";